// import Icon from 'icons/Icon';
import React from 'react';
import { useMetadataValue } from './Components';
import { BaseProps } from './Component.type';

function UnknownComponent(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: BaseProps<any>,
  ref: React.Ref<HTMLDivElement>,
) {
  const { appUid, itemType, itemId, pageId } = props;
  const metaProps = useMetadataValue(appUid, pageId, itemId, itemType);
  const {
    visible,
    visibleCondition,
    comments,
    responsive,
    className,
    ...otherProps
  } = metaProps;
  console.warn(`Unknown Component ${itemType}`, itemId, otherProps);
  return (
    <span
      ref={ref}
      data-tip={`Unknown Component ${itemType}!\nItemID: ${itemId}\nProperties: ${JSON.stringify(
        otherProps,
        null,
        '  ',
      )}`}
      data-tip-onclick
      data-tip-at="bottom"
      style={{ display: 'inline-block', cursor: 'pointer', zIndex: 9 }}
    >
      {/* <Icon iconName="bug" color="error" iconType="duotone" /> */}
    </span>
  );
}

export default React.forwardRef(UnknownComponent);
